<template>
  <v-card
    v-if="features"
    flat
    tile
  >
    <template v-if="dense && parcel && !config.hideParcelsInfos && features.length">
      <v-tabs v-model="tab">
        <v-tab>
          Détails
        </v-tab>
        <v-tab>
          Cadastre
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-text>
            <v-window v-model="currentFeature">
              <v-window-item
                v-for="(feature, i) in features"
                :key="`card-${i}`"
              >
                <v-list
                  :class="`transparent${dense ? ' py-0' : ''}`"
                  dense
                >
                  <v-list-item
                    v-for="field in config.tooltip"
                    :key="field"
                    class="px-0"
                  >
                    <v-list-item-content
                      class="py-0"
                      style="flex:1.6"
                    >
                      {{ fields[field].title || fields[field]['x-originalName'] || fields[field].key }}
                    </v-list-item-content>
                    <v-list-item-content
                      style="align-items:flex-end"
                      class="py-0 pl-2 font-weight-bold text-body-2"
                    >
                      {{ formattedField(feature, field) }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-btn
                  v-if="linkField && feature[linkField.key]"
                  :href="(!feature[linkField.key].includes('http') ? 'http://' : '') + feature[linkField.key]"
                  text
                  small
                  target="_blank"
                  class="px-6"
                  color="primary"
                >
                  Page associée
                </v-btn>
                <v-btn
                  v-if="attachmentField && feature[attachmentField.key]"
                  :href="(!feature[attachmentField.key].includes('http') ? (datasetUrl + '/attachments/') : '') + feature[attachmentField.key]"
                  text
                  small
                  target="_blank"
                  class="px-6"
                  color="primary"
                >
                  Document associé
                </v-btn>
              </v-window-item>
            </v-window>
          </v-card-text>
          <v-card-actions
            v-if="features.length > 1"
            class="justify-space-between"
          >
            <v-btn
              icon
              @click="prev"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-item-group
              v-model="currentFeature"
              class="text-center"
              mandatory
            >
              <v-item
                v-for="(feature, n) in features"
                :key="`btn-${n}`"
              >
                <v-btn
                  slot-scope="{ active, toggle }"
                  :input-value="active"
                  style="width:8px;height:8px"
                  icon
                  @click="toggle"
                >
                  <v-icon
                    :size="active ? 14: 8"
                    :style="(active ? `margin-top:-3px;`: '') + `color:${color(feature)}`"
                  >
                    mdi-circle
                  </v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
            <v-btn
              icon
              @click="next"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-list
              :class="`transparent${dense ? ' py-0' : ''}`"
              dense
            >
              <v-list-item
                v-for="field in ['id', 'commune', 'prefixe', 'section', 'numero', 'contenance']"
                :key="field"
                style="min-height:28px"
                class="px-0"
              >
                <v-list-item-content
                  class="py-0"
                  style="flex:1.6"
                >
                  {{ field }}
                </v-list-item-content>
                <v-list-item-content
                  style="align-items:flex-end"
                  class="py-0 pl-2 font-weight-bold text-body-2"
                >
                  {{ parcel[field] }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <v-card-text
        v-if="parcel && !config.hideParcelsInfos"
        class="py-0"
      >
        <v-subheader>Informations du cadastre</v-subheader>
        <v-list
          :class="`transparent${dense ? ' py-0' : ''}`"
          dense
        >
          <v-list-item
            v-for="field in ['id', 'commune', 'prefixe', 'section', 'numero', 'contenance']"
            :key="field"
            style="min-height:28px"
            class="px-0"
          >
            <v-list-item-content
              class="py-0"
              style="flex:1.6"
            >
              {{ field }}
            </v-list-item-content>
            <v-list-item-content
              style="align-items:flex-end"
              class="py-0 pl-2 font-weight-bold text-body-2"
            >
              {{ parcel[field] }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text
        v-if="features.length"
        class="py-0"
      >
        <v-divider
          v-if="parcel && !config.hideParcelsInfos"
          class="mt-2"
        />
        <v-subheader v-if="parcel && !config.hideParcelsInfos">
          Informations additionnelles
        </v-subheader>
        <div
          v-else
          class="pt-2"
          style="width:100%"
        />
        <v-window v-model="currentFeature">
          <v-window-item
            v-for="(feature, i) in features"
            :key="`card-${i}`"
          >
            <v-list
              :class="`transparent${dense ? ' py-0' : ''}`"
              dense
            >
              <v-list-item
                v-for="field in config.tooltip"
                :key="field"
                class="px-0"
              >
                <v-list-item-content
                  class="py-0"
                  style="flex:1.6"
                >
                  {{ fields[field].title || fields[field]['x-originalName'] || fields[field].key }}
                </v-list-item-content>
                <v-list-item-content
                  style="align-items:flex-end"
                  class="py-0 pl-2 font-weight-bold text-body-2"
                >
                  {{ formattedField(feature, field) }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-btn
              v-if="linkField && feature[linkField.key]"
              :href="(!feature[linkField.key].includes('http') ? 'http://' : '') + feature[linkField.key]"
              text
              small
              target="_blank"
              class="px-6"
              color="primary"
            >
              Page associée
            </v-btn>
            <v-btn
              v-if="attachmentField && feature[attachmentField.key]"
              :href="(!feature[attachmentField.key].includes('http') ? (datasetUrl + '/attachments/') : '') + feature[attachmentField.key]"
              text
              small
              target="_blank"
              class="px-6"
              color="primary"
            >
              Document associé
            </v-btn>
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-card-actions
        v-if="features.length > 1"
        class="justify-space-between"
      >
        <v-btn
          icon
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="currentFeature"
          class="text-center"
          mandatory
        >
          <v-item
            v-for="(feature, n) in features"
            :key="`btn-${n}`"
          >
            <v-btn
              slot-scope="{ active, toggle }"
              :input-value="active"
              style="width:8px;height:8px"
              icon
              @click="toggle"
            >
              <v-icon
                :size="active ? 14: 8"
                :style="(active ? `margin-top:-3px;`: '') + `color:${color(feature)}`"
              >
                mdi-circle
              </v-icon>
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          icon
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  props: {
    dense: { type: Boolean, default: false }
  },
  data: () => ({
    currentFeature: 0,
    tab: null
  }),
  computed: {
    ...mapState(['parcel', 'features']),
    ...mapGetters(['config', 'defaultColor', 'legend', 'linkField', 'attachmentField', 'datasetUrl', 'schema']),
    fields () {
      return this.schema.reduce((a, b) => { a[b.key] = b; return a }, {})
    }
  },
  methods: {
    next () {
      this.currentFeature = this.currentFeature + 1 === this.features.length ? 0 : this.currentFeature + 1
    },
    prev () {
      this.currentFeature = this.currentFeature - 1 < 0 ? this.features.length - 1 : this.currentFeature - 1
    },
    color (feature) {
      if (!this.config.colorField) return this.legend[0][1]
      const c = this.legend.find(l => l[0] === (feature[this.config.colorField]) + '')
      if (c) return c[1]
      return this.defaultColor
    },
    formattedField (feature, field) {
      if (!feature[field]) return ''
      const f = this.fields[field]
      if (f['x-labels']) return f['x-labels'][feature[field]]
      if (f.type === 'number' || f.type === 'integer') return feature[field].toLocaleString()
      if (f['x-refersTo'] === 'http://schema.org/Date') return dayjs(feature[field]).format('DD/MM/YYYY')
      return feature[field]
    }
  }
}
</script>
